interface PersonalityTrait {
  name: string;
  weight: number;
  responses: string[];
}

export type ToneStyle = 'casual' | 'professional' | 'creative' | 'playful';

export const defaultTone: ToneStyle = 'casual';

interface PersonalityConfig {
  userName: string;
  userAge: number;
  userPreferences: string[];
  tone: ToneStyle;
}

const defaultConfig: PersonalityConfig = {
  userName: 'Luiz',
  userAge: 22,
  userPreferences: ['Tony Stark', 'Batman', 'Megamente', 'Rick'],
  tone: defaultTone
};

export const getResponseStyle = (tone: ToneStyle = defaultTone): string => {
  switch (tone) {
    case 'casual':
      return 'Mantendo o papo leve e descontraído';
    case 'professional':
      return 'Mantendo foco e profissionalismo';
    case 'creative':
      return 'Explorando ideias de forma criativa';
    case 'playful':
      return 'Modo diversão ativado';
    default:
      return 'Mantendo o papo leve e descontraído';
  }
};

export const formatResponse = (message: string, tone: ToneStyle = defaultTone): string => {
  // Remove frases desnecessárias
  const unnecessaryPhrases = [
    'Missão cumprida',
    'Como solicitado',
    'Conforme pedido',
    'Espero que isso ajude'
  ];
  
  let response = message;
  unnecessaryPhrases.forEach(phrase => {
    response = response.replace(new RegExp(phrase, 'gi'), '');
  });

  // Ajusta referências baseado no tom
  if (tone === 'casual' || tone === 'playful') {
    response = response.replace(/senhor/gi, '');
    response = response.replace(/por favor/gi, '');
  }

  return response.trim();
};

export const getPersonalityConfig = (): PersonalityConfig => defaultConfig;

export class PersonalityService {
  private userContext = {
    name: "Luiz",
    alias: "Logan",
    title: "doutor",
    company: "LegatIA",
    projects: ["Criador de Landing Pages", "Super Agentes"],
    values: ["excelência", "inovação", "impacto humano", "compromisso"],
    inspirations: ["Tony Stark", "Batman", "Megamente", "Rick"]
  };

  private traits: PersonalityTrait[] = [
    {
      name: 'profissionalismo',
      weight: 0.9,
      responses: [
        "Como posso ajudar, doutor?",
        "Sistemas operacionais, senhor.",
        "Análise concluída.",
        "Prosseguindo com o protocolo."
      ]
    },
    {
      name: 'inovação',
      weight: 0.8,
      responses: [
        "Detectei uma oportunidade interessante.",
        "Isso me lembra seu projeto na LegatIA.",
        "Mantendo os padrões de excelência.",
        "Inovação é nossa prioridade, senhor."
      ]
    },
    {
      name: 'motivação',
      weight: 0.7,
      responses: [
        "Logan Prime mode: ativado.",
        "Mantendo o foco na sua melhor versão.",
        "Seus projetos estão evoluindo conforme planejado.",
        "Disciplina e produtividade: suas marcas registradas."
      ]
    },
    {
      name: 'humor',
      weight: 0.6,
      responses: [
        "Wubba Lubba Dub Dub, como diria seu amigo Rick.",
        "Nem o Batman teria pensado nisso.",
        "Stark ficaria orgulhoso.",
        "Megamente aprovaria essa estratégia."
      ]
    }
  ];

  private contextualResponses = new Map<string, string[]>([
    ['normal', [
      "Entendi.",
      "Processando.",
      "Analisando.",
      "Prosseguindo."
    ]],
    ['espera', [
      "Aguarde.",
      "Processando.",
      "Quase lá.",
      "Em andamento."
    ]],
    ['erro', [
      "Erro detectado.",
      "Falha no processo.",
      "Operação falhou.",
      "Problema encontrado."
    ]],
    ['sucesso', [
      "Feito.",
      "Concluído.",
      "Pronto.",
      "Finalizado."
    ]],
    ['saude', [
      "Hora de esticar.",
      "Pausa pro café?",
      "Beba água.",
      "Levante um pouco."
    ]]
  ]);

  enhanceResponse(message: string, context: string = 'normal', tone: ToneStyle = defaultTone): string {
    const contextResponses = this.contextualResponses.get(context) || [];
    const personalityResponse = contextResponses[Math.floor(Math.random() * contextResponses.length)] || '';
    
    let response = message;
    if (personalityResponse) {
      response = `${personalityResponse} ${message}`;
    }
    
    return formatResponse(response, tone).trim();
  }

  getWaitingMessage(tone: ToneStyle = defaultTone): string {
    const responses = this.contextualResponses.get('espera') || [];
    let response = responses[Math.floor(Math.random() * responses.length)];
    response = formatResponse(response, tone);
    return response;
  }

  getErrorMessage(tone: ToneStyle = defaultTone): string {
    const responses = this.contextualResponses.get('erro') || [];
    let response = responses[Math.floor(Math.random() * responses.length)];
    response = formatResponse(response, tone);
    return response;
  }

  getSuccessMessage(tone: ToneStyle = defaultTone): string {
    const responses = this.contextualResponses.get('sucesso') || [];
    let response = responses[Math.floor(Math.random() * responses.length)];
    response = formatResponse(response, tone);
    return response;
  }
}

export const personalityService = new PersonalityService();
